import { useQuery } from "@tanstack/react-query";

import { ListBookMonthsQueryFilters, UseListBookMonthsQueryOptions } from "./types";
import { getBookMonthsService } from "./service";

export const listBookMonthsQueryKey = ["book_month_admin"];

export function useListBookMonthsQuery(
  filters?: ListBookMonthsQueryFilters,
  options?: UseListBookMonthsQueryOptions
) {
  const queryKey = listBookMonthsQueryKey.concat(JSON.stringify(filters) as any);

  return useQuery({
    queryKey,
    queryFn: () => getBookMonthsService(filters),
    ...options,
  });
}
